import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-page-no-license',
  templateUrl: './page-no-license.component.html',
  styleUrls: ['./page-no-license.component.scss'],
  standalone: true
})
export class PageNoLicenseComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}

